import { lazy } from 'react';

export const LazyVideoDesk = lazy(() => import('../../components/VideoDesk/VideoDesk'));
export const LazyVideoMovil = lazy(() => import('../../components/VideoMovil/VideoMovil'));
export const LazyContact = lazy(() => import('../../components/contact/Contacts'));